export default __webpack_public_path__ + "static/media/other24.b796f8f0.webp";